import React from 'react';
import { formatMoney } from '../utils';
import { useStyles } from "../hooks/useStyles";
//import { ShopperContext } from '../context/shopper';

export const TripCostLink = ( {shortname, outlay, outlayWithTax,
                                cstu,
                                currency} ) => {
  const { textAlignRight } = useStyles();
  const currency_symbol  = currency;
  const currency_subunit = cstu;

  return (
    <tr>
      <td>
        {shortname}
      </td>

      <td style={textAlignRight}>
        {formatMoney({amount: outlay, currency_symbol, currency_subunit})}
      </td>

      <td style={textAlignRight}>
        {
          outlayWithTax
            ? <span>
      {formatMoney({amount: outlayWithTax, currency_symbol, currency_subunit})}
              </span>
            : <span>--</span>
        }
      </td>
    </tr>
  )
}

export default TripCostLink